function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ctquktayta",
  d: "M11.672 1.875l.103.009c.34.057.57.38.513.72l-.369 2.187c2.123.185 3.637.813 3.637 2.709v6.944c0 .612-.271 1.16-.695 1.542v1.236c0 .382-.312.695-.694.695h-.695c-.382 0-.694-.313-.694-.695v-.694H7.222v.694c0 .382-.312.695-.694.695h-.695c-.382 0-.694-.313-.694-.695v-1.236c-.424-.382-.695-.93-.695-1.542V7.5c0-1.789 1.347-2.45 3.282-2.673l.408-2.43.02-.083c.09-.294.387-.483.7-.43.34.057.57.38.512.72l-.358 2.133c.322-.01.653-.015.992-.015.224 0 .445.002.662.006l.393-2.332.02-.083c.092-.294.388-.482.7-.43zm-4.797 11.18c-.576 0-1.042.466-1.042 1.042 0 .577.466 1.042 1.042 1.042.576 0 1.042-.465 1.042-1.042 0-.576-.466-1.041-1.042-1.041zm6.25 0c-.576 0-1.042.466-1.042 1.042 0 .577.466 1.042 1.042 1.042.576 0 1.042-.465 1.042-1.042 0-.576-.466-1.041-1.042-1.041zm.208-6.388H6.667c-.46 0-.834.373-.834.833v4.306h8.334V7.5c0-.46-.373-.833-.834-.833z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-234 -509) translate(18.444 509) translate(215.556)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "j6bqh0tswb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ctquktayta"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#263238",
  fillRule: "nonzero",
  xlinkHref: "#ctquktayta"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#j6bqh0tswb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H20.2V20.2H0z"
}))));
function Svg24Trolleybus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Trolleybus);
export default __webpack_public_path__ + "static/media/24-trolleybus.f5ba116a693a71f4241c3f7aebaadf27.svg";
export { ForwardRef as ReactComponent };